import React from 'react'
import DocumentTitle from 'react-document-title'
import Spinner from 'react-spinkit'
import { PreferencesBox, SizeWidget, TtlWidget } from '../components'
import preferences from '../http/preferences'

export default class PreferencesPage extends React.Component {
  constructor (props){
    super(props)

    this.state = {
      loading: false,
      preferencesList: [],
    }
  }

  componentDidMount() {
    this.fetch()
  }

  setSize(category, size, cb) {
    preferences.setSize(category, size, (status) => {
      if (status) {
        cb(status)
      }
    })
  }

  setTtl(category, days, cb) {
    preferences.setTtl(category, days, (status) => {
      if (status) {
        cb(status)
      }
    })
  }

  showPreferences(results) {
    this.setState({
      preferencesList: results,
      loading: false,
    })
  }

  fetch() {
    this.setState({
      loading: true,
    })
    let mapping = {
      0: 'All',
      395: 'Audio',
      404: 'eBook',
      340: 'Emulation',
      624: 'Jeu vidéo',
      392: 'GPS',
      233: 'Application',
      210: 'Film/Vidéo',
      211: 'Série',
      456: 'xXx',
    }
    preferences.fetchAll((results) => {
      let cleanedResults = results.map((result) => ({
        id: result.id,
        category: mapping[Number(result.id)],
        size: <SizeWidget key={'size-' + result.id} setSize={this.setSize.bind(this)} id={result.id} size={result.size} />,
        ttl: <TtlWidget key={'ttl-' + result.id} setTtl={this.setTtl.bind(this)} id={result.id} ttl={result.ttl} />,
      }))
      this.showPreferences(cleanedResults)
    })
  }

  render() {
    return (
      <DocumentTitle title={'Café App'}>
      <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h3>Preferences (Taille limite DL auto / Délai auto-suppression) {this.state.loading ? <Spinner spinnerName="three-bounce" className="col-xs-1 pull-right" noFadeIn /> : ''}</h3>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <PreferencesBox preferencesList={this.state.preferencesList} />
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}
